export default __webpack_public_path__ + "static/media/bit_bubbles@3x.729a3b89.png";